import { tabCloser, tabTemplate, categoryCodeTab } from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeDatasetSettings } from '../actions';
import DatasetAdminActions from '../containers/DatasetAdminActions';
import DatasetAdminPanel from '../components/DatasetAdminPanel';

export default {
  ...tabTemplate('dataset-settings', DatasetAdminPanel, matchSingleUrl(['datasets', 'settings']), DatasetAdminActions),
  ...tabCloser('closeDatasetManageTab', closeDatasetSettings),
  access: ({ datasets }) => datasets.update,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
  dropDownIcon: 'settings',
  icon: 'fas fa-sliders-h',
  order: 230,
};
